import { Component } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-reports',
    imports: [
        MatIcon
    ],
  templateUrl: './reports.html',
  styleUrl: './reports.css',
})
export class Reports {

}
